<!-- 项目文件 -->
<template>
	<div>
		<Header :Logo="logo" :city="cityName" :Link="link" :TitleList="titleList" :Color="color"></Header>

		<div class="w1200 mauto pb50">
			<div class="mt20 overflow pb40 posre">
				<div class="floatl w50p posre">
					<!-- Swiper -->
					<div class="h400">
						<div class="gallery-top-box  ">
							<div class="swiper-container gallery-top swiper-no-swiping" style="height: 400px;">
								<div class="swiper-wrapper" v-if="schoolDetail.bannerList.length > 0">
									<div class="swiper-slide  w100p" v-for="(item, index) in schoolDetail.bannerList" :key="index">
										<img class="imgauto" :src="item || 'schoolDetail.image'" alt="" />
									</div>
								</div>
								<div class="swiper-wrapper w100p" v-if="schoolDetail.bannerList.length == 0">
									<div class="swiper-slide  w100p"><img class="imgauto" :src="schoolDetail.image" alt="" /></div>
								</div>
							</div>
						</div>
						<div class="gallery-thumbs-box mt30  ">
							<div class="swiper-container gallery-thumbs overflow posre" style="height: 100px;">
								<div class="swiper-wrapper  display_flex justify-content_flex-justify" v-if="schoolDetail.bannerList.length > 0">
									<div class="swiper-slide w100p" v-for="(item, index) in schoolDetail.bannerList" :key="index">
										<img class="imgauto" :src="item || 'https://365taoke.oss-cn-hangzhou.aliyuncs.com/card/20200429/img1.png'" alt="" />
									</div>
								</div>

								<div class="swiper-wrapper w100p  display_flex justify-content_flex-justify" v-if="schoolDetail.bannerList.length == 0">
									<div class="swiper-slide  w100p"><img class="imgauto" :src="schoolDetail.image" alt="" /></div>
								</div>

								<div class="swiper-button-next "></div>
								<div class="swiper-button-prev  "></div>
							</div>
						</div>
					</div>
				</div>

				<div class="floatr w50p posre">
					<div class="pl30 pt10 ">
						<div class="bbe8 pb20">
							<div class="alit">
								<span class="fs22 fbold c333">{{ schoolDetail.name }}</span>
								<span class="pl10 "><img v-for="(v, i) in schoolDetail.medals" class="w16 h16 mr5" :src="v.medal_img" alt="" /></span>
							</div>
							<P class="mt20 overflow">
								<span class="c999 fs14 pr20 floatl">地址</span>
								<span class="fs16 c333">{{ schoolDetail.adress }}</span>
							</P>
							<P class="mt20 overflow">
								<span class="c999 fs14 pr20 floatl">评星</span>
								<span class="alit floatl" v-if="schoolDetail.starImg">
									<!-- <img v-for="(item,index) in schoolDetail.starImg" class="w16 h16  mr10" src="../../public/img/img80.png" alt=""> -->
									<img v-for="(v, i) in parseInt(schoolDetail.starImg)" :key="i" class="w16 h16 mr6" src="../../public/img/img80_1.png" alt="" />
									<img v-if="parseInt(schoolDetail.starImg) != schoolDetail.starImg" class="w16 h16 mr6" src="../../public/img/img80_3.png" alt="" />
									<img
										v-if="schoolDetail.starImg < 4.1"
										v-for="(vv, ii) in 5 - Math.ceil(schoolDetail.starImg)"
										class="w16 h16 mr6"
										src="../../public/img/img80_2.png"
										alt=""
									/>
									<i class="fs14 cff96">{{ schoolDetail.starImg }}</i>
								</span>
								<span class="alit floatl" v-else>暂无评分</span>
							</P>
							<P class="mt20 overflow ">
								<span class="c999 fs14 pr20  verbot">价格</span>
								<span>
									<span class="cff0 fs28 fbold">
										<i class="fs14 cff0">¥</i>
										{{ schoolDetail.min_price }}
									</span>
									<!-- <span class="c999 fs16 pl8 line-through">
                                        门店价¥3200
                                    </span> -->
								</span>
							</P>
						</div>

						<div class="mt20  bbe8 pb20">
							<span class="c999 fs14 pr20 floatl">班型</span>
							<ul class="disinblock w90p row1_txtc posre zindex1">
								<!-- @mouseenter="enter($event,item.begin_time,item.training_num,item.course_hours,item.get_card_time,item.selling_point)"
                                @mouseleave="leave($event)" -->
								<li
									v-for="(item, index) in schoolDetail.class_list"
									@mouseover="mouseOver(item.installment_price_int)"
									class="changeTag posre mb8 posre w30p disinblock  cursor"
								>
									<p class="pl25 border6 bgf6 disflex posre zindex1 pr25 pt10 pb10 overflow">
										<span class="floatl c666 fs14 over_1">{{ item.class_name }}</span>
										<span class="c666 fs16 pl10 floatr">{{ icon }}</span>
									</p>
									<div class="posab tag1 zindex999 pt15 pb15 pr15 pl15 bgfff disnone">
										<p>上车时间：{{ item.begin_time }}</p>
										<p>练车方式： {{ item.training_num }}</p>
										<p>学车课时： {{ item.course_hours }}</p>
										<p>拿证时间：{{ item.get_card_time }}</p>
										<p>特色服务：{{ item.selling_point }}</p>
									</div>
								</li>
							</ul>
						</div>
						<div class="pt30 w100p">
							<span @click="open(schoolId)" class="fs20 disinblock cursor cfff pl60 bg1f8 pr60 pt10 pb10 textc">立即报名</span>
							<span class="disinblock pl16">
								<img src="../../public/img/x6.png" alt="" />
								<span class="c333 fs16 pl10">
									<i class="cff96 fs16">{{ schoolDetail.comment }}</i>
									条评论
								</span>
							</span>
						</div>
					</div>
				</div>
			</div>
			<div class="mt30 overflow   posre">
				<div class="w70p floatl">
					<!-- 评论组件 -->
					<Comment :Description="schoolDetail.description" :Name="schoolDetail.name" :Strength="schoolDetail.strength" :SchoolId="schoolId"></Comment>
				</div>

				<div class="w25p  floatr">
					<!-- 报名组件 -->
					<Recommend :OrderType="schoolDetail.class_list" :Area_id="area_idX"></Recommend>
				</div>
			</div>
		</div>
		<div class="posfix bgrg w100p h100p zindex999 overflow top0 left0" v-show="mask == 1">
			<div class="posab left30p top30p bgfff w30p pt20 pb20 pl40 pr40 bradius8">
				<p class=" fbold fs20 c1f8 textc">立即报名</p>
				<span @click="choose()" class="disinblock posab top0 right11 fs26 c333 cursor">×</span>
				<div class="pt20 pb20">
					<ul class="pt10 pb5">
						<li class="mt8 mb8 posre">
							<span class="w40 disinblock baee h40 bgf6 posab top0 left0 alit">
								<i class="w100p textc"><img class="w14 h16" src="../../public/img/img75.png" /></i>
							</span>
							<input class="w100p baee h40 outline textindent3 fs14 c999" v-model="Name" type="text" placeholder="请输入姓名" />
						</li>
						<li class="mt8 mb8 posre">
							<span class="w40 disinblock baee h40 bgf6 posab top0 left0 alit">
								<i class="w100p textc"><img class="w12 h16" src="../../public/img/img76.png" /></i>
							</span>
							<input class="w100p baee h40 outline textindent3 fs14 c999" v-model="Phone" type="text" placeholder="请输入手机号" />
						</li>
						<li class="mt8 mb8 posre">
							<span class="w40 disinblock baee h40 bgf6 posab top0 left0 alit">
								<i class="w100p textc"><img class="w12 h14" src="../../public/img/img77.png" /></i>
							</span>
							<input class="w100p baee h40 outline textindent3 fs14 c999" type="text" v-model="Code" placeholder="请输入验证码" />
							<span v-show="show" @click="getCode" class="pt4 pb4 pl10 pr10 bgeaf disinblock posab top6 right8 c1f8 fs12 bradius5 cursor">获取验证码</span>
							<span v-show="!show" class="pt4 pb4 pl10 pr10 bgeaf disinblock posab top6 right8 c1f8 fs12 bradius5 cursor">{{ count }} s</span>
						</li>
					</ul>
					<p @click="Submit()" class=" h40 lh40 bradius8 cursor mt15 mb15 cfff bg1f8 textc fbold fs18">确认提交</p>
				</div>
			</div>
		</div>
		<Footer></Footer>
	</div>
</template>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Recommend from '@/components/Recommend';
import Comment from '@/components/Comment';
import $ from 'jquery';
export default {
	data() {
		return {
			color: 1,
			link: 2,
			titleList: 4,
			logo: 'home',
			cityName: '',
			schoolId: '',
			schoolDetail: {
				name: '',
				adress: '',
				star: '',
				starImg: '',
				min_price: '',
				class_list: [],
				comment: '',
				bannerList: [],
				description: '',
				strength: '',
				name1: ''
			},
			area_idX: '',
			icon: '∨',
			mask: 0,
			Name: '',
			Phone: '',
			count: '',
			show: true,
			Code: ''
		};
	},
	components: {
		Header,
		Footer,
		Recommend,
		Comment
	},
	methods: {
		getDetail() {
			let that = this;
			this.schoolId = this.$route.query.schoolId;
			$.ajax({
				type: 'POST',
				url: that.beseAjax + '/school/getSchoolDetail.do',
				dataType: 'json',
				async: false,
				data: {
					school_id: that.schoolId
				},
				success: function(data) {
					console.log(data);
					that.schoolDetail.name = data.obj.school_name;
					that.schoolDetail.adress = data.obj.school_address;
					//that.schoolDetail.star = data.obj.star;
					that.schoolDetail.starImg = data.obj.star;
					that.schoolDetail.min_price = data.obj.min_price;
					that.schoolDetail.class_list = data.obj.class_list;
					that.schoolDetail.comment = data.obj.comment_count;
					that.schoolDetail.bannerList = data.obj.imgs;
					that.schoolDetail.image = data.obj.image;

					that.schoolDetail.description = data.obj.description;
					that.schoolDetail.medals = data.obj.medals;

					// that.schoolDetail.strength = data.obj.strength;
					that.schoolDetail.name1 = data.obj.name;
				},
				error: function(data) {
					console.log(data);
				}
			});
		},
		mouseOver(item) {
			this.schoolDetail.min_price = item;
		},
		open(id) {
			this.School_id = id;
			this.mask = 1;
			$('body').css('overflow', 'hidden');
		},
		choose() {
			this.mask = 0;
			$('body').css('overflow', 'auto');
		},
		getCode() {
			//验证码
			let that = this;
			if (!/^1[23456789]\d{9}$/.test(that.Phone)) {
				alert('请正确输入手机号');
				return 0;
			} else {
				const TIME_COUNT = 60;
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.show = false;
					this.timer = setInterval(() => {
						if (this.count > 0 && this.count <= TIME_COUNT) {
							this.count--;
						} else {
							this.show = true;
							clearInterval(this.timer);
							this.timer = null;
						}
					}, 1000);
				}
				$.ajax({
					type: 'POST',
					url: that.beseAjax + '/school/sendSmsCode.do',
					dataType: 'json',
					async: false,
					data: {
						phone: that.Phone,
						type: 'login'
					},
					success: function(data) {
						console.log(data);
					},
					error: function(data) {
						console.log(data);
					}
				});
			}
		},
		Submit() {
			let that = this;

			if (that.Name == '' || !/^1[23456789]\d{9}$/.test(that.Phone) || that.Code == '') {
				alert('请正确输入');
				return 0;
			} else {
				$.ajax({
					type: 'POST',
					url: that.beseAjax + '/school/bmdj.do',
					dataType: 'json',
					async: false,
					data: {
						phone: that.Phone,
						name: that.Name,
						code: that.Code,
						school_id: that.School_id
					},
					success: function(data) {
						console.log(data);
						if (data.code == '0') {
							alert('提交成功');
							that.choose();
							that.Phone = '';
							that.Name = '';
							that.Code = '';
						} else {
							alert(data.info);
						}
					},
					error: function(data) {
						alert('网络异常，请稍后重试！');
					}
				});
			}
		}
	},

	created() {
		this.cityName = this.$store.state.cityName;
		this.area_idX = this.$route.query.cityid;

		this.getDetail();
	},
	mounted() {
		var leftScreenVal, moveLeftVal;
		var galleryTop = new Swiper('.gallery-top', {
			nextButton: '.swiper-button-next',
			prevButton: '.swiper-button-prev',
			observer: true,
			observeParents: true
		});
		var galleryThumbs = new Swiper('.gallery-thumbs', {
			centeredSlides: true,
			slidesPerView: 3,
			// touchRatio: 0.2,
			slideToClickedSlide: true,
			observer: true,
			observeParents: true
		});

		galleryTop.params.control = galleryThumbs;
		galleryThumbs.params.control = galleryTop;
	}
};
</script>
<style scoped>
.gallery-thumbs .swiper-slide {
	width: 23%;
	opacity: 0.4;
	padding: 0 1%;
}

.gallery-thumbs .swiper-slide-active {
	opacity: 1;
}

.swiper-button-next {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L5%2C44l-4.2-4.2L18.6%2C22L0.8%2C4.2L5%2C0z'%20fill%3D'%23cccccc'%2F%3E%3C%2Fsvg%3E");
}

.swiper-button-prev {
	background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l4.2%2C4.2L8.4%2C22l17.8%2C17.8L22%2C44L0%2C22z'%20fill%3D'%23cccccc'%2F%3E%3C%2Fsvg%3E");
}

.row1_txtc:after {
	content: '';
	display: block;
	clear: both;
	width: 30%;
}

/deep/.swiper-container,
.swiper-button-prev,
.swiper-button-next {
	z-index: auto;
}

.changeTag:hover .tag1 {
	display: block;
}

.bgrg {
	background: rgba(0, 0, 0, 0.5);
}
</style>
